/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Ua_Static_CaptionInputs */

const en_bot_ua_static_caption = /** @type {(inputs: Bot_Ua_Static_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML reading`)
};

const id_bot_ua_static_caption = /** @type {(inputs: Bot_Ua_Static_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembacaan HTML`)
};

/**
* | output |
* | --- |
* | "HTML reading" |
*
* @param {Bot_Ua_Static_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_ua_static_caption = /** @type {((inputs?: Bot_Ua_Static_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Ua_Static_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_ua_static_caption(inputs)
	return en_bot_ua_static_caption(inputs)
});